"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Form_1 = require("./Form");
var types_1 = require("./types");
var SubFormInner = /** @class */ (function (_super) {
    __extends(SubFormInner, _super);
    function SubFormInner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubFormInner.prototype.render = function () {
        return (React.createElement(types_1.FormContextProvider, { value: { form: this } }, this.props.children));
    };
    return SubFormInner;
}(Form_1.default));
/**
 * OUI SubForm component.
 * A SubForm is a grouping of inputs within a Form with it's own validation and serialization logic.
 * Serialization is done via the "transformData" prop (often to merge multiple inputs into a single data structure),
 * then the resulting data is added to the outer Form under whichever "fieldName" is given to the SubForm.
 *
 * @oui-component SubForm
 */
var SubForm = function (_a) {
    var fieldName = _a.fieldName, transformData = _a.transformData, validator = _a.validator, defaultValues = _a.defaultValues, subFormRef = _a.subFormRef, children = _a.children;
    var outerForm = React.useContext(types_1.FormContext).form;
    var innerForm = React.useRef();
    var innerFormRef = React.useCallback(function (ref) {
        innerForm.current = ref;
        subFormRef && subFormRef(ref);
        return ref;
    }, [innerForm, subFormRef]);
    // Keep track of if the component has mounted
    var _b = __read(React.useState(false), 2), mounted = _b[0], setMounted = _b[1];
    React.useEffect(function () {
        setMounted(true);
    }, []);
    // Transform and set the values in the parent form.  Do it silently
    // if we haven't finished the mount yet
    var onChange = React.useCallback(function (form) {
        var values = form.getValues();
        outerForm.setValue(fieldName, transformData(values), !mounted);
    }, [fieldName, transformData, outerForm, mounted]);
    // Register/unregister ourselves with parent form
    React.useEffect(function () {
        outerForm.mountSubForm(innerForm.current, fieldName);
        return function () { return outerForm.unmountSubForm(innerForm.current, fieldName); };
    }, []);
    // We use loadState to set the initial value on mount, using the previous subform state if present
    // or otherwise the default values.
    var loadState = React.useCallback(function (_a, _) {
        var defaultValues = _a.defaultValues;
        if (outerForm.getCachedSubformState) {
            var priorState = outerForm.getCachedSubformState(fieldName);
            if (priorState) {
                return __assign({}, priorState, { errors: {}, isDirty: false, nestedErrors: {}, touched: {}, submittedWithErrors: false });
            }
        }
        var values = outerForm.getPreviousSubformState(fieldName) || defaultValues;
        return {
            values: values,
            subForms: {},
            subFormValues: {},
            subFormState: {},
            errors: {},
            isDirty: false,
            nestedErrors: {},
            touched: {},
            submittedWithErrors: false
        };
    }, [outerForm, fieldName]);
    return (React.createElement(SubFormInner, { onChange: onChange, validator: validator, defaultValues: defaultValues, formRef: innerFormRef, loadState: loadState }, children));
};
exports.default = SubForm;
//# sourceMappingURL=SubForm.js.map